/* eslint-disable no-nested-ternary */
import React, { FC } from 'react';
import { styled } from 'linaria/react';
import { checkIsDenominationSelected } from '@entities/denomination';
import { getSingleTspType, TspPageDenomination, TspPagePayee, useCyberStore } from '@entities/tsp';
import { getTspEventContent } from '@features/payment/payment-form';
import { paymentTarifClickGtm } from '@shared/lib/gtm/redesign';
import { Button } from '@shared/ui/molecules';
import { CircleCheckIcon } from '@shared/assets/icons';
import { getSelectDenominationButtonColor } from '../lib/getSelectDenominationButtonColor';
import { getSelectDenominationButtonIconColor } from '../lib/getSelectDenominationButtonIconColor';
import { getSelectDenominationButtonTextColor } from '../lib/getSelectDenominationButtonTextColor';
interface SelectDenominationButtonProps {
  payee: TspPagePayee;
  denomination: TspPageDenomination;
  price: string | undefined;
  isSoldOut: boolean;
}
const SelectDenominationButton: FC<SelectDenominationButtonProps> = ({
  payee,
  denomination,
  price,
  isSoldOut
}) => {
  const {
    activeDenomination,
    setActiveDenomination
  } = useCyberStore();
  const handleDenominationSelect = () => {
    const eventContent = getTspEventContent(payee);
    const tariff = denomination.features?.buttonLabel || '';
    paymentTarifClickGtm(eventContent, {
      productName: payee.providerName,
      denomination: tariff
    });
    setActiveDenomination(denomination);
  };
  const type = getSingleTspType(payee);
  const isSelected = checkIsDenominationSelected(denomination, activeDenomination);
  return <Button type="button" size={{
    desktop: '44',
    mobile: '32'
  }} disabled={isSoldOut} startIcon={isSelected && <CircleCheckIconWrapper color={getSelectDenominationButtonIconColor(type, denomination.features?.colorsubcategory as string)}>
            <CircleCheckIcon />
          </CircleCheckIconWrapper>} color={getSelectDenominationButtonColor(isSelected, type, denomination.features?.colorsubcategory as string)} textColor={getSelectDenominationButtonTextColor(isSelected, type, denomination.features?.colorsubcategory as string)} onClick={handleDenominationSelect}>
      {isSelected ? 'Выбрано' : isSoldOut ? 'Раскупили' : `${price} ₽`}
    </Button>;
};
export default SelectDenominationButton;
interface CircleCheckIconWrapperProps {
  color: string;
}
const _exp = /*#__PURE__*/() => ({
  color
}) => color;
const CircleCheckIconWrapper = /*#__PURE__*/styled('div')({
  name: "CircleCheckIconWrapper",
  class: "ccvdjqp",
  propsAsIs: false,
  vars: {
    "ccvdjqp-0": [_exp()]
  }
});

require("./SelectDenominationButton.linaria.module.css!=!../../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./SelectDenominationButton.tsx");